import React from 'react';
import { IconButton, Tooltip, IconButtonProps } from '@mui/material';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import { useTranslation } from 'react-i18next';

interface ToolsIconProps extends Omit<IconButtonProps, 'children'> {
  /** Custom tooltip text. Defaults to translated "These tools can be used on this item" */
  tooltipText?: string;
  /** Whether to show the tooltip. Defaults to true */
  showTooltip?: boolean;
}

/**
 * Reusable component for displaying a construction tools icon with tooltip.
 * Used to indicate that tools can be used on an item/filter/etc.
 */
export default function ToolsIcon({
  tooltipText,
  showTooltip = true,
  sx,
  ...props
}: ToolsIconProps) {
  const { t } = useTranslation();

  // Default tooltip text with fallback
  const defaultTooltipText = t('common.toolsTooltip', 'These tools can be used on this item');
  const finalTooltipText = tooltipText || defaultTooltipText;

  const iconButton = (
    <IconButton
      size="small"
      sx={{
        color: '#FFD700',
        '&:hover': {
          color: '#FFD700',
        },
        ...sx,
      }}
      {...props}
    >
      <ConstructionOutlinedIcon fontSize="small" />
    </IconButton>
  );

  if (!showTooltip) {
    return iconButton;
  }

  return <Tooltip title={finalTooltipText}>{iconButton}</Tooltip>;
}
